import { render, staticRenderFns } from "./BaseCounter.vue?vue&type=template&id=512c474e&scoped=true&"
import script from "./BaseCounter.vue?vue&type=script&lang=js&"
export * from "./BaseCounter.vue?vue&type=script&lang=js&"
import style0 from "./BaseCounter.vue?vue&type=style&index=0&id=512c474e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c474e",
  null
  
)

export default component.exports